import { Component, inject } from '@angular/core';
import { ChildrenOutletContexts, RouterModule } from '@angular/router'
import { slideInAnimation } from './route-animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  imports: [RouterModule],
  styleUrl: './app.scss',
  animations: [slideInAnimation]
})
export class App {
  private contexts = inject(ChildrenOutletContexts);

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
